(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvoroost-home"] && !Shopify.designMode) return;
  try {
    
function setupNuvoroost(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const cards=[...root.querySelectorAll('.nr-product')];let saved=[];
 try{const parsed=JSON.parse(localStorage.getItem('nuvoroost-favorites')||'[]');if(Array.isArray(parsed))saved=parsed.filter(x=>typeof x==='string')}catch(e){}
 let filter='all';
 const status=root.querySelector('.nr-save-status');
 const refresh=()=>{cards.forEach(card=>{const chosen=saved.includes(card.dataset.id);const button=card.querySelector('.nr-save');button.setAttribute('aria-pressed',String(chosen));button.textContent=chosen?'♥':'♡';card.hidden=filter==='saved'?!chosen:filter!=='all'&&card.dataset.category!==filter});root.querySelector('.nr-saved-count').textContent=saved.length;root.querySelector('.nr-empty').hidden=filter!=='saved'||cards.some(c=>!c.hidden)};
 root.querySelectorAll('[data-filter]').forEach(button=>button.addEventListener('click',()=>{filter=button.dataset.filter;root.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));refresh()}));
 cards.forEach(card=>card.querySelector('.nr-save').addEventListener('click',()=>{const id=card.dataset.id;saved=saved.includes(id)?saved.filter(x=>x!==id):[...saved,id];try{localStorage.setItem('nuvoroost-favorites',JSON.stringify(saved));status.textContent=''}catch(e){status.textContent=root.dataset.storageMessage}refresh()}));
 const form=root.querySelector('.nr-finder');form.addEventListener('submit',event=>{event.preventDefault();const result=root.querySelector('.nr-finder-result');result.href=form.elements.room.value;result.hidden=false;const tips={start:root.dataset.tipStart,space:root.dataset.tipSpace,routine:root.dataset.tipRoutine};root.querySelector('.nr-finder-tip').textContent=tips[form.elements.goal.value]||''});
 refresh();
}
document.querySelectorAll('.nr-home').forEach(setupNuvoroost);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.nr-home').forEach(setupNuvoroost));

  } catch(e) { console.error(e); }
})();
})();
